"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloseIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const makeIcon_1 = require("./makeIcon");
const Close = props => ((0, jsx_runtime_1.jsx)("svg", Object.assign({ width: "16px", height: "16px", viewBox: "0 0 16 16" }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: "M2.974 2L2 2.974 7.026 8 2 13.026l.974.974L8 8.974 13.026 14l.974-.974L8.974 8 14 2.974 13.026 2 8 7.026 2.974 2z" }, void 0) }), void 0));
exports.CloseIcon = (0, makeIcon_1.makeIcon)('close')(Close);
//# sourceMappingURL=Close.js.map